module.exports = __webpack_public_path__ + "img/wrench.a5389bb8.svg";